/**
 * Shared USD currency formatter — consolidates ~25 inline
 * `Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', ... })`
 * call sites that had drifted into 4 different null/zero-handling
 * conventions. Pass `emptyDisplay` to preserve a call site's existing
 * empty-state text; omit it to fall back to treating a nullish value as 0
 * (the most common prior convention, `v || 0`).
 */
export function formatCurrency(v, { decimals = 0, emptyDisplay = null } = {}) {
  const isEmpty = v === null || v === undefined || v === '' || Number.isNaN(v);
  if (isEmpty && emptyDisplay !== null) return emptyDisplay;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(isEmpty ? 0 : v);
}
